import { render } from "./introduce.vue?vue&type=template&id=16a10a92&scoped=true"
import script from "./introduce.vue?vue&type=script&lang=js"
export * from "./introduce.vue?vue&type=script&lang=js"

import "./introduce.vue?vue&type=style&index=0&id=16a10a92&lang=scss&scoped=true"

import exportComponent from "/www/publicHouse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16a10a92"]])

export default __exports__